import type {
	SchoolsControllerSearchSchoolsQueryParams
} from '@/global/api/gen/ts/schoolsDTO/SchoolsControllerSearchSchools';

export const JournalKeys = {
	all: ['journal'] as const,
	search: (params: SchoolsControllerSearchSchoolsQueryParams) => [...JournalKeys.all, 'search', params] as const
};